module.exports = __webpack_public_path__ + "static/3-db4977cee0df144364687a74726006fa.png";